import { DAIMI_MF_INTRO, DAIMI_MF_SLUG } from '@/content/daimiManufacturing'
import { focus } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The twenty-eighth report with a designed page of its own, and the thirteenth
  // focus cut to arrive with both of its figures — asked for on 2026-08-28 in the
  // same words as the Pharmaceuticals and Public Services cuts before it (*"referans
  // alarak ilgili sayfayı birebir tıpa tıp aynısını tasarla"*) with a four-part
  // full-page capture of the live page, the cover as two overlapping 2000px crops,
  // Figure 1 and the report mockup. See `content/daimiManufacturing.ts` and
  // `pages/DaimiManufacturing.tsx`. Not to be confused with the Future 2030
  // Manufacturing outlook further down, which is a separate report on
  // `'manufacturing-outlook'`.
  ...focus(
    DAIMI_MF_SLUG,
    'Manufacturing',
    'daimi-report-2026-manufacturing-cover',
    'f64e64a2-1ba5-4c09-9537-fac2aef4ab78-digitopia-daimi-2026-report-manufacturing.pdf',
  ),
  // The sector's own paragraphs, transcribed from the reference capture and held on
  // the page that says them — so the search result and the page cannot drift apart.
  // `prerender.tsx` takes the meta description from `body[0]`.
  body: DAIMI_MF_INTRO.body,
  layout: 'manufacturing-focus',
  // Its own words, its cover, its file and both of its figures, so `stillToCome`
  // has nothing left to say about it. What is still open is section-by-section on
  // its page, and `daimiManufacturingChecks()` carries that into the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 12
